import { render } from "./GiftCardPreview.vue?vue&type=template&id=c4a21440"
import script from "./GiftCardPreview.vue?vue&type=script&lang=js"
export * from "./GiftCardPreview.vue?vue&type=script&lang=js"

import "./GiftCardPreview.vue?vue&type=style&index=0&id=c4a21440&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__